module.exports = __webpack_public_path__ + "static/media/icon_report.06de5b46.svg";